import React from 'react'

const Jobs = () => {
    return (
        <div className='jobs'><p>Software Developer</p><p>Security Analyst </p><p>Cloud Engineer</p></div>
    )
}

export default Jobs